import { PlusIcon } from './PlusIcon.jsx';
import styles from './AddItemButton.module.css';

export function AddItemButton(props) {
  return (
    <button className={styles.button} type="button" {...props}>
      <PlusIcon />
      Legg til gjeld
    </button>
  );
}
